var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/setting-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "setting-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.1 9.61999C18.29 9.61999 17.55 8.33999 18.45 6.76999C18.97 5.85999 18.66 4.69999 17.75 4.17999L16.02 3.18999C15.23 2.71999 14.21 2.99999 13.74 3.78999L13.63 3.97999C12.73 5.54999 11.25 5.54999 10.34 3.97999L10.23 3.78999C9.78 2.99999 8.76 2.71999 7.97 3.18999L6.24 4.17999C5.33 4.69999 5.02 5.86999 5.54 6.77999C6.45 8.33999 5.71 9.61999 3.9 9.61999C2.86 9.61999 2 10.47 2 11.52V13.28C2 14.32 2.85 15.18 3.9 15.18C5.71 15.18 6.45 16.46 5.54 18.03C5.02 18.94 5.33 20.1 6.24 20.62L7.97 21.61C8.76 22.08 9.78 21.8 10.25 21.01L10.36 20.82C11.26 19.25 12.74 19.25 13.65 20.82L13.76 21.01C14.23 21.8 15.25 22.08 16.04 21.61L17.77 20.62C18.68 20.1 18.99 18.93 18.47 18.03C17.56 16.46 18.3 15.18 20.11 15.18C21.15 15.18 22.01 14.33 22.01 13.28V11.52C22 10.48 21.15 9.61999 20.1 9.61999ZM12 15.65C10.21 15.65 8.75 14.19 8.75 12.4C8.75 10.61 10.21 9.14999 12 9.14999C13.79 9.14999 15.25 10.61 15.25 12.4C15.25 14.19 13.79 15.65 12 15.65Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting2);
export default __webpack_public_path__ + "static/media/setting-2.20671e902015160ed5374e2d51c4506b.svg";
export { ForwardRef as ReactComponent };